const CrossCircleIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className || "w-4 h-4"}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#clip0_6572_5142)"
    >
      <path d="M8.003 14.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334M10 6l-4 4M6 6l4 4"></path>
    </g>
    <defs>
      <clipPath id="clip0_6572_5142">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CrossCircleIcon;
